import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2, X } from "lucide-react";
import { api, formatApiError } from "../lib/api";

export const ImageUpload = ({ value, onChange, testId }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Photo téléchargée !");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="flex items-center gap-3">
      <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/gif,image/webp" className="hidden" onChange={handleFile} data-testid={`${testId}-file`} />
      {value ? (
        <div className="relative shrink-0">
          <img src={value} alt="aperçu" className="w-14 h-14 rounded-lg object-cover border border-white/10" />
          <button type="button" data-testid={`${testId}-clear`} onClick={() => onChange("")} className="absolute -top-2 -right-2 bg-black border border-white/20 rounded-full p-0.5 text-gray-400 hover:text-white">
            <X size={12} />
          </button>
        </div>
      ) : null}
      <button type="button" data-testid={`${testId}-btn`} disabled={uploading} onClick={() => inputRef.current?.click()} className="btn-outline-gold !py-2 !px-4 text-xs disabled:opacity-50 shrink-0">
        {uploading ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />}
        {uploading ? "Envoi…" : "Télécharger une photo"}
      </button>
      <input data-testid={testId} className="ic-input !py-2 text-xs flex-1 min-w-0" placeholder="ou collez une URL d'image" value={value || ""} onChange={(e) => onChange(e.target.value)} />
    </div>
  );
};
